export default "__VITE_PUBLIC_ASSET__aba8ef63__"